import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { REQUEST } from "../../../../config/ajax-wrapper";
import { Form } from "react-final-form";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DotLoader } from "react-spinners";
import { consultarMaestroTransaccionesSat } from "../../../general/modulos/maestrosActions";
import { FiltroConsultaHistoricoMsj } from "../modelo/ReporteHistoricoModelo";
import NumericInput from "../../../general/componentes/NumericInput";
import TipoIdentificacion from "../../../general/componentes/TipoIdentificacion";
import { FiltrosTransaccion } from "../../config_general/modelo/FiltrosPorTransaccion";
import TextoInput from "../../../general/componentes/TextoInput";
import { consultarHistoricosMensaje, descargarXLSTablaHistoricoMsj } from "../modulos/consultaHistoricosActions";
import TablaHistoricoMensajes from "./TablaHistoricoMensajes";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import {
    codigoCentroTrabajo,
    codigoSede,
    documentoEmpleado,
    documentoEmpleador,
    poliza,
    tipoDocumentoEmpleado,
    tipoDocumentoEmpleador,
    fechaInicialConsulta,
    fechaFinalConsulta,
    selectorServicios,
    periodoMora
} from "../../config_general/modelo/TextosAyuda";
import SelectorDesplegable from "../../config_general/componentes/SelectorDesplegable";
import DatePickerSura from "../../../general/componentes/DatePicker";
import { Item } from "../../config_general/modelo/ItemsListaDesplegabe";
import DivisorConTexto from "../../config_general/componentes/DivisorConTexto";
import * as moment from "moment";
import { textoPeriodoCumple } from "../../config_general/modelo/FuncionesComunes";
import ModalDescargaPartesXLS from "../../config_general/componentes/ModalDescargaPartesXLS";

class FiltrosConsultaHistoricos extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            listaServicios: [],
            showModalGestion: false,
            mostrarModalDescarga: false
        };
    }

    componentWillMount() {
        if (!this.props.transaccionesSat || this.props.transaccionesSat.length === 0) {
            this.props.dispatch(consultarMaestroTransaccionesSat());
        }
    }

    componentDidUpdate() {
        if (this.props.transaccionesSat && this.props.transaccionesSat.length !== 0 && this.state.listaServicios.length === 0) {
            this.construirItems();
        }
    }

    render() {
        const { totalDatosConsulta } = this.props;

        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Consulta Tablas Históricos</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Filtros consulta histórico</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label>Fecha Inicial</label>
                                                <TextoAyuda texto={fechaInicialConsulta} />
                                                <DatePickerSura name={"fechaInicial"} fechaMaxima={moment()} />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Final</label>
                                                <TextoAyuda texto={fechaFinalConsulta} />
                                                <DatePickerSura name={"fechaFinal"} fechaMaxima={moment()} />
                                            </Col>
                                        </Row>
                                        <br />
                                        <DivisorConTexto texto="opcional" />
                                        <br />
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumento">Tipo Documento Empleador</label>
                                                <TextoAyuda texto={tipoDocumentoEmpleador} />
                                                <TipoIdentificacion name="tipoDocumento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documento">Documento Empleador</label>
                                                <TextoAyuda texto={documentoEmpleador} />
                                                <NumericInput name="documento" placeholder="Ingrese un documento" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="numeroPoliza">Póliza</label>
                                                <TextoAyuda texto={poliza} />
                                                <NumericInput name="numeroPoliza" />
                                            </Col>
                                            {this.renderFiltroPeriodo()}
                                        </Row>
                                        {this.renderFiltroPorTransaccion()}
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label>Filtro Servicios</label>
                                                <TextoAyuda texto={selectorServicios} />
                                                <SelectorDesplegable
                                                    name={"serviciosSeleccionados"}
                                                    listaDesplegable={this.state.listaServicios} />
                                            </Col>
                                        </Row>
                                        <div style={{ marginTop: `25px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    {totalDatosConsulta > 0 &&
                                                        <a className="btns btn-success" onClick={this.mostrarModalDescarga}>
                                                            <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                        </a>
                                                    }
                                                    {this.state.mostrarModalDescarga && this.renderModalXLS()}
                                                </Col>
                                                <Col smOffset={6} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderTablaConsultaHistoricos()}
                </Row>
            </div>
        );
    }

    renderFiltroPeriodo() {
        const servicios = this.state.listaServicios;

        const servicioConPeriodo = () =>
            servicios && servicios.some(servicio => servicio.seleccionado && FiltrosTransaccion.periodo.indexOf(servicio.codigo) >= 0);

        if (servicioConPeriodo()) {
            return (
                <Col sm={2}>
                    <label htmlFor="periodoMora">Periodo en Mora</label>
                    <TextoAyuda texto={periodoMora} />
                    <NumericInput name="periodoMora" />
                </Col>
            );
        }
        return false;

    }

    renderFiltroPorTransaccion() {
        let sede, centroTrabajo, dniAfiliado;
        const servicios = this.state.listaServicios;

        const servicioConSede = () =>
            servicios && servicios.some(servicio => servicio.seleccionado && FiltrosTransaccion.sedes.indexOf(servicio.codigo) >= 0);

        const servicioConCT = () =>
            servicios && servicios.some(servicio => servicio.seleccionado && FiltrosTransaccion.centroTrabajo.indexOf(servicio.codigo) >= 0);

        const servicioConAfiliado = () =>
            servicios && servicios.some(servicio => servicio.seleccionado && FiltrosTransaccion.dniAfiliado.indexOf(servicio.codigo) >= 0);

        if (servicioConSede()) {
            sede = (
                <Col sm={3}>
                    <label htmlFor="codigoSede">Sede</label>
                    <TextoAyuda texto={codigoSede} />
                    <TextoInput name="codigoSede" placeholder="Ingrese código de la Sede" maxLength={10} />
                </Col>
            );
        }
        if (servicioConCT()) {
            centroTrabajo = (
                <Col sm={3}>
                    <label htmlFor="codigoCentroT">Centro Trabajo</label>
                    <TextoAyuda texto={codigoCentroTrabajo} />
                    <TextoInput name="codigoCentroT" placeholder="Ingrese código del Centro" maxLength={10} />
                </Col>
            );
        }
        if (servicioConAfiliado()) {
            dniAfiliado = (
                <div>
                    <Col sm={3}>
                        <label htmlFor="tipoDocumentoEmpleado">Tipo Documento Empleado</label>
                        <TextoAyuda texto={tipoDocumentoEmpleado} />
                        <TipoIdentificacion name="tipoDocumentoEmpleado" />
                    </Col>
                    <Col sm={3}>
                        <label htmlFor="documentoEmpleado">Documento Empleado</label>
                        <TextoAyuda texto={documentoEmpleado} />
                        <NumericInput name="documentoEmpleado" placeholder="Ingrese un documento" />
                    </Col>
                </div>
            );
        }

        return (
            <Row className={"form-group"}>
                {sede}
                {centroTrabajo}
                {dniAfiliado}
            </Row>
        );

    }

    renderTablaConsultaHistoricos() {
        const { datosRespuestaMsj, estado, paginas, tamanoPagina, paginaActual } = this.props;

        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (!datosRespuestaMsj || !datosRespuestaMsj.length)
                    return (
                        <span>
                            <Mensaje type={"info"} mensaje={"No se han encontrado parámetros"} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <TablaHistoricoMensajes
                                respuestasTSAT={datosRespuestaMsj}
                                filtro={this.filtros()}
                                paginas={paginas}
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual}
                                consultaPaginada={this.consultaPaginada}
                            />
                        </span>
                    );
            default:
                return false;
        }
    }

    filtros(): FiltroConsultaHistoricoMsj {
        return {
            fechaInicial: this.state.fechaInicial,
            fechaFinal: this.state.fechaFinal,
            listaServicios: this.state.listaServicios,
            dniEmpleador: this.state.dniEmpleador,
            poliza: this.state.numeroPoliza,
            codigoSede: this.state.codigoSede,
            codigoCentroTrabajo: this.state.codigoCentroT,
            dniEmpleado: this.state.dniEmpleado,
            periodo: this.state.periodoMora
        };
    }

    consultaPaginada = (filtro: FiltroConsultaHistoricoMsj) => {
        this.props.dispatch(consultarHistoricosMensaje(filtro));
    };

    onSubmit = (values: any) => {
        this.props.dispatch(consultarHistoricosMensaje(this.obtenerValores(values)));
    };

    obtenerValores = (values: any) => {

        const fechaInicial = values.fechaInicial ? values.fechaInicial.valueOf() : undefined;
        const fechaFinal = values.fechaFinal ? values.fechaFinal.valueOf() : undefined;
        const numeroPoliza = values.numeroPoliza ? values.numeroPoliza.valueOf() : undefined;
        const dniEmpleador = values.tipoDocumentoEmpleador && values.documentoEmpleador ? (values.tipoDocumentoEmpleador + values.documentoEmpleador) : undefined;
        const codigoSede = values.codigoSede ? values.codigoSede.valueOf() : undefined;
        const codigoCentroT = values.codigoCentroT ? values.codigoCentroT.valueOf() : undefined;
        const dniEmpleado = (values.tipoDocumentoEmpleado && values.documentoEmpleado) ? (values.tipoDocumentoEmpleado + values.documentoEmpleado) : undefined;
        const periodoMora = values.periodoMora ? values.periodoMora : undefined;
        const serviciosSeleccionados = values.serviciosSeleccionados ? values.serviciosSeleccionados : [];

        const filtro: FiltroConsultaHistoricoMsj = {
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            listaServicios: serviciosSeleccionados,
            dniEmpleador: dniEmpleador,
            poliza: numeroPoliza,
            codigoSede: codigoSede,
            codigoCentroTrabajo: codigoCentroT,
            dniEmpleado: dniEmpleado,
            periodo: periodoMora,
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0
        };

        this.setState({
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal,
            listaServicios: serviciosSeleccionados,
            dniEmpleador: dniEmpleador,
            poliza: numeroPoliza,
            codigoSede: codigoSede,
            codigoCentroTrabajo: codigoCentroT,
            dniEmpleado: dniEmpleado,
            periodo: periodoMora,
            filtro: filtro
        });

        return filtro;
    };

    validate = (values: any) => {
        const errors = {
            fechaInicial: undefined,
            fechaFinal: undefined,
            tipoDocumento: undefined,
            documento: undefined,
            documentoEmpleado: undefined,
            tipoDocumentoEmpleado: undefined,
            periodoMora: undefined
        };

        if (!values.fechaInicial && !values.fechaFinal)
            errors.fechaInicial = "Por favor seleccione una fecha como filtro para continuar";

        if (values.fechaInicial && !values.fechaFinal)
            errors.fechaFinal = "Por favor selecciona una fecha de fin";

        if (!values.fechaInicial && values.fechaFinal)
            errors.fechaInicial = "Por favor selecciona una fecha de inicio";

        if (values.fechaInicial && values.fechaFinal && (values.fechaInicial.isAfter(values.fechaFinal)))
            errors.fechaFinal = "La fecha final no puede ser anterior a la fecha inicial";

        if (values.tipoDocumento && !values.documento)
            errors.documento = "Se debe ingresar un documento";

        if (!values.tipoDocumento && values.documento)
            errors.tipoDocumento = "Se debe seleccionar un tipo de documento";

        if (values.tipoDocumentoEmpleado && !values.documentoEmpleado)
            errors.documentoEmpleado = "Se debe ingresar un documento";

        if (!values.tipoDocumentoEmpleado && values.documentoEmpleado)
            errors.tipoDocumentoEmpleado = "Se debe seleccionar un tipo de documento";

        if (values.periodoMora && !textoPeriodoCumple(values.periodoMora))
            errors.periodoMora = "El texto del periodo no cumple con el formato.";

        return errors;
    };

    construirItems = () => {
        const { transaccionesSat } = this.props;
        const items = [];
        transaccionesSat.filter(servicio => servicio.esGestionable)
            .forEach(servicio => {
                const item: Item = {
                    texto: servicio.nombre,
                    codigo: servicio.codigo,
                    seleccionado: false,
                    bloqueado: false
                };
                items.push(item);
            });

        this.setState({ listaServicios: items });
    };

    mostrarModalDescarga = () => {
        this.setState({ mostrarModalDescarga: true });
    };

    cerrarModalDescarga = () => {
        this.setState({ mostrarModalDescarga: false });
    };

    renderModalXLS = () => {
        const { totalDatosConsulta } = this.props;
        return (
            <ModalDescargaPartesXLS
                titulo={"Reporte Historico Mensaje"}
                totalRegistros={totalDatosConsulta}
                verModalXLS={this.state.mostrarModalDescarga}
                cantidadDescargaReporte={1000}
                closeModalXLS={this.cerrarModalDescarga}
                generarXLS={this.generarXLS}
            />
        );
    };

    generarXLS = (numeroReporte: number, cantidadRegistros: number) => {
        const filtro: FiltroConsultaHistoricoMsj = {
            fechaInicial: this.state.fechaInicial,
            fechaFinal: this.state.fechaFinal,
            listaServicios: this.state.serviciosSeleccionados,
            dniEmpleador: this.state.dniEmpleador,
            poliza: this.state.numeroPoliza,
            codigoSede: this.state.codigoSede,
            codigoCentroTrabajo: this.state.codigoCentroT,
            dniEmpleado: this.state.dniEmpleado,
            periodo: this.state.periodoMora,
            tamanoPagina: cantidadRegistros,
            paginaActual: numeroReporte
        };

        this.cerrarModalDescarga();
        this.props.dispatch(descargarXLSTablaHistoricoMsj(filtro));
    };

}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        transaccionesSat: R.pathOr([], ["maestros", "transaccionesSat"])(store),
        estado: R.pathOr([], ["consulta_tabla_historicos", "estado"])(store),
        estadoDescarga: R.pathOr([], ["consulta_tabla_historicos", "estadoDescarga"])(store),
        datosRespuestaMsj: R.pathOr([], ["consulta_tabla_historicos", "datosRespuestaMsj"])(store),
        paginas: R.pathOr([], ["consulta_tabla_historicos", "paginas"])(store),
        paginaActual: R.pathOr([], ["consulta_tabla_historicos", "paginaActual"])(store),
        tamanoPagina: R.pathOr([], ["consulta_tabla_historicos", "tamanoPagina"])(store),
        totalDatosConsulta: R.pathOr([], ["consulta_tabla_historicos", "totalDatosConsulta"])(store)
    };
})(FiltrosConsultaHistoricos);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/consulta_tabla_historicos/componentes/FiltrosConsultaHistoricos.tsx